// extracted by mini-css-extract-plugin
export default {"modal":"InviteToTestingModal_modal__8J5W4","contentHeading":"InviteToTestingModal_contentHeading__2j3xM","contentWrap":"InviteToTestingModal_contentWrap__07A0b"};